module.exports = __webpack_public_path__ + "media/images/practice-underline-01-2e4456527cc7511da44ccefe033368282898eee96ecfeee5d0bf4aa54a31e5d8.svg";